import menu from "../assets/imgs/menu.svg";
import shareNow from "../assets/imgs/share_now.svg";
import rotobotAi from "../assets/imgs/rotobot_ai.svg";
import { useLocation } from "react-router-dom";
import AccountModal from "../Components/AccountModal/AccountModal";
import SettingsModal from "../Components/SettingsModal/SettingsModal";
import { actions } from "../Redux/store";
import rotoFeed from "../assets/imgs/roto_feed.svg";
import { hapticsImpactLight } from "../lib/utils";
import { useMixpanel } from "../Context/MixpanelContext/MixpanelProvider";
import { shareContent } from "../Services/shareContent";
import history from "../assets/imgs/history.svg";

export default function Header() {
	const location = useLocation();
	const currentPath = location.pathname;
	const chatbotAiRouter = ["/chatbot-ai"];
	const Mixpanel = useMixpanel();
	const isChatbotRoute = chatbotAiRouter.includes(currentPath);

	const openSettingModal = () => {
		hapticsImpactLight();
		Mixpanel.trackEvent("settings_selected", {
			name: "User clicked the settings button",
		});
		actions.modal.openSettingsModal(null);
	};

	const openChatBotHistoryModal = () => {
		hapticsImpactLight();
		Mixpanel.trackEvent("chat_history_selected", {
			name: "User clicked the chat history button",
		});
		actions.modal.openChatBotHistoryModal(null);
	};

	const navigateToShareScreen = async () => {
		try {
			Mixpanel.trackEvent("click_share_button", {
				name: "User clicked the share button",
			});
			hapticsImpactLight();
			await shareContent({
				title: "RotoBot AI",
				text: "AI Meets Fantasy Football",
				url: "https://apps.apple.com/us/app/rotobot-ai/id6502530085",
			});
		} catch (error) {
			console.error("Error sharing:", error);
		}
	};

	return (
		<>
			<div className="flex items-center justify-between px-5 pt-5 pl-2 pr-2">
				{/* Left Menu Button - Fixed container size */}
				<div
					className="cursor-pointer w-12 h-12 flex items-center justify-center"
					onClick={openSettingModal}
				>
					<img src={menu} alt="menu-icon" className="w-6 h-6" />
				</div>

				{/* Center Logo */}
				<img src={rotobotAi} alt="rotobot-ai-icon" />

				{/* Right Action Button - Fixed container size to prevent layout shifts */}
				<div className="w-12 h-12 flex items-center justify-center cursor-pointer">
					{isChatbotRoute ? (
						<div onClick={openChatBotHistoryModal} className="w-full h-full flex items-center justify-center">
							<img
								src={history}
								alt="Chat History"
								className="w-6 h-6 transition-opacity duration-200"
							/>
						</div>
					) : (
						<div onClick={navigateToShareScreen} className="w-full h-full flex items-center justify-center">
							<img
								src={shareNow}
								alt="Share App"
								className="w-[26.25px] h-[25px] transition-opacity duration-200"
							/>
						</div>
					)}
				</div>
			</div>

			<AccountModal />
			<SettingsModal />
		</>
	);
}
